
import service from '../request/index'

// 我的学时证明
export function proofList (data) {
  return service({
    url: '/api/premiumCourse/front/my/proofList',
    method: 'get',
    params: data
  })
}


// 申请学时证明
export function applicantCertificate (data) {
  return service({
    url: '/api/premiumCourse/front/my/applicantCertificate',
    method: 'put',
    params: data
  })
}


// 前端个人学习空间
export function myData (data) {
  return service({
    url: '/api/premiumCourse/front/my/studySpace',
    method: 'get',
    params: data
  })
}


// 学时使用明细列表
export function periodConsumeList (data) {
  return service({
    url: '/api/premiumCourse/front/my/periodConsumeList',
    method: 'get',
    params: data
  })
}


// 学习记录列表
export function studyList (data) {
  return service({
    url: '/api/premiumCourse/front/my/studyList',
    method: 'get',
    params: data
  })
}


// 保存课程时长(二期)
export function saveTime (data) {
  return service({
    url: '/api/course/resource/saveTime',
    method: 'get',
    params: data
  })
}